import { CollectionComponent } from "@aidkitorg/types/lib/survey";
import { createPaymentModule } from "@aidkitorg/types/lib/macros/payments";

export type MacroDefinition = (macroConfiguration: any) => CollectionComponent[];

export const MACROS: Record<string, MacroDefinition> = {
  createPaymentModule,
};